import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {SharedVarService} from '../shared-service.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  myForm: UntypedFormGroup;
  submitted: boolean = false;
  userNotFound: boolean = false;
  emailNotFound: boolean = false;
  clientRequest: ClientRequest;
  myUser = {} as User;
  subscription: Subscription;
  maherError: string;
  @ViewChild("username1") userField: ElementRef;


  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent, private  globalEventsManager: GlobalEventsManager,  private service: SharedVarService) {


    this.myForm = fb.group({
      username: ['', [Validators.required]]});

  }

  get f() { return this.myForm.controls;}

  ngOnInit() {


  }

  ngAfterViewInit(): void {
    setTimeout(() => this.userField.nativeElement.focus());

  }


  sendEmail(){
    this.submitted = true;
    this.userNotFound = false;
    this.emailNotFound = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.requestData = [];
    this.clientRequest.user = this.myUser;
    if (this.myForm.valid) {
      const lhsUserObs$ = this.queryService.resetPassword(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.myUser = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.maherError = null;
          if (this.myUser.maherError != null && this.myUser.maherError!="") {
              //this.maherError = this.myUser.maherError
          }else{
            this.service.setUsername(this.myUser.username);
            this.router.navigate(["/confirm"]);
          }

        });
    }


  }



  returnBack(){
    this.router.navigate([""]);

  }
}
